const $win = $(window);

$('.js-nav-block > ul > li > span, .js-nav-block > ul > li > a').on('click', function(e) {
  const $this = $(this);

  if ($this.siblings('ul').length) {
    if($win.width() < 768) {
      e.preventDefault();

      $this
        .next()
        .slideToggle()
        .parent()
        .toggleClass('expanded')
        .siblings()
        .removeClass('expanded')
        .find('.nav__dropdown')
        .slideUp();
    }
  }
});



// WEBPACK FOOTER //
// ../assets/js/nav-block-mobile.js